import {
  Box,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import link1 from "../../assets/pdfs/academic/TimeTable/BPT1TT.pdf";
import link2 from "../../assets/pdfs/academic/TimeTable/BPT2TT.pdf";
import link3 from "../../assets/pdfs/academic/TimeTable/BPT3TT.pdf";
import link4 from "../../assets/pdfs/academic/TimeTable/BPT4TT.pdf";
import link5 from "../../assets/pdfs/academic/TimeTable/MPT1TT.pdf";
import link6 from "../../assets/pdfs/academic/TimeTable/MPT2TT.pdf";

import link7 from "../../assets/pdfs/academic/TimeTable/timetable I BPT 25-26.pdf";
import link8 from "../../assets/pdfs/academic/TimeTable/2nd bpth summer batch 26 timetable.pdf";
import link9 from "../../assets/pdfs/academic/TimeTable/3rd year bpt Time table pdf.pdf";
import link10 from "../../assets/pdfs/academic/TimeTable/4th year summer bath timetable 25-26.pdf";

type Props = {};

interface TimetableLinkObj {
  yearName: string;
  timetableLink: string;
}
interface LectureTimeTableObject {
  courseName: string;
  years: Array<TimetableLinkObj>;
}

const lectureTimetableData: Array<LectureTimeTableObject> = [
  {
    courseName: "Bachelor’s of Physiotherapy",
    years: [
      {
        yearName: "1st  year BPT",
        timetableLink: link7,
      },
      {
        yearName: "2nd  year BPT",
        timetableLink: link8,
      },
      {
        yearName: "3rd  year BPT",
        timetableLink: link9,
      },
      {
        yearName: "4th  year BPT",
        timetableLink: link10,
      },
    ],
  },
  {
    courseName: "Master’s of Physiotherapy",
    years: [
      {
        yearName: "1st  year MPT",
        timetableLink: link5,
      },
      {
        yearName: "2nd  year MPT",
        timetableLink: link6,
      },
    ],
  },
];

const LectureTimeTable = (props: Props) => {
  const [selectedSubTab, setSelectedSubTab] = useState<string | "">("");

  function Subtabs(tabDetails: {
    subTabName: string;
    lectureTimeTableLink: string;
  }) {
    const yearName = tabDetails?.subTabName;
    return (
      <Grid item key={tabDetails?.subTabName} xs="auto" sx={{ my: 1 }}>
        <a
          href={tabDetails.lectureTimeTableLink}
          target="_blank"
          style={{ textDecoration: "none" }}
        >
          <Chip
            label={
              <Typography fontWeight={"bold"}>
                {yearName
                  .split(" ")[0]
                  .slice(0, yearName.split(" ")[0].length - 2)}
                <span
                  style={{
                    fontSize: "0.75em",
                    verticalAlign: "super",
                    textTransform: "lowercase",
                  }}
                >
                  {yearName
                    .split(" ")[0]
                    .split("")
                    .slice(
                      yearName.split(" ")[0].split("").length - 2,
                      yearName.split(" ")[0].split("").length
                    )}
                </span>
                &nbsp;{" "}
                {yearName
                  .split(" ")
                  .slice(1, yearName.split(" ").length)
                  .join(" ")}
              </Typography>
            }
            variant="filled"
            sx={{
              color:
                tabDetails?.subTabName === selectedSubTab
                  ? "secondary.main"
                  : "white",
              backgroundColor:
                tabDetails?.subTabName === selectedSubTab
                  ? "transparent"
                  : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "none",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
          />
        </a>
      </Grid>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        {lectureTimetableData.map((item, i) => {
          return (
            <React.Fragment key={item.courseName}>
              <Typography variant="h5" sx={{ fontWeight: "bold" }} gutterBottom>
                {item.courseName}
              </Typography>
              <List>
                {item.years.map((yearObj, i) => {
                  return (
                    <ListItem key={item.courseName + yearObj.yearName}>
                      {Subtabs({
                        subTabName: yearObj.yearName,
                        lectureTimeTableLink: yearObj.timetableLink,
                      })}
                    </ListItem>
                  );
                })}
              </List>
            </React.Fragment>
          );
        })}
        {/* 
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Bachelor’s of Physiotherapy
        </Typography>
        <List>
          <ListItem>
            {Subtabs({ subTabName: "", lectureTimeTableLink: "#" })}
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                1
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  st
                </span>
                &nbsp; year BPT
              </Typography>
            </a>
          </ListItem>
          <ListItem>
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                2
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  nd
                </span>
                &nbsp; year BPT
              </Typography>
            </a>
          </ListItem>
          <ListItem>
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                3
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  rd
                </span>
                &nbsp; year BPT
              </Typography>
            </a>
          </ListItem>
          <ListItem>
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                4
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  th
                </span>
                &nbsp; year BPT
              </Typography>
            </a>
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Master’s of Physiotherapy
        </Typography>
        <List>
          <ListItem>
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                1
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  st
                </span>
                &nbsp; year MPT
              </Typography>
            </a>
          </ListItem>
          <ListItem>
            <a href="#" style={{ textDecoration: "none" }}>
              <Typography>
                2
                <span style={{ fontSize: "0.75em", verticalAlign: "super" }}>
                  nd
                </span>
                &nbsp; year MPT
              </Typography>
            </a>
          </ListItem>
        </List> */}
      </Stack>
    </Box>
  );
};

export default LectureTimeTable;
